export const getProductDisplayModel = (product) =>
  product?.displaymodelno || product?.mainmodelno || product?.modelno || "Product";